<section class="circle-gradient overflow-hidden">
    <div class="breadcrumb-sec event-sec">
        <div class="container">
            <div class="row g-0">
                <div class="col-md-6">
                    <ul class="breadcrumb">
                        <li><a href="https://raisoni.net/">Home</a></li>
                        <li><i class="fa fa-angle-right"></i></li>
                        <li><a href="events-new">Events</a></li>
                        <li><i class="fa fa-angle-right"></i></li>
                        <li><a href="events-new#cultural">Cultural</a></li>
                        <li><i class="fa fa-angle-right"></i></li>
                        <li>Farewell Party 2026 </li>
                    </ul>
                    <div class="sec-title">
                        <h1><span>Farewell Party 2026 </span></h1>
                        <p>"Farewell Party 2026 at GHRCACS Nagpur was all about celebrating journeys, friendships, and
                            the moments that made college life unforgettable. From laughter and performances to
                            heartfelt goodbyes, every moment was filled with emotions and memories we’ll carry forward.

                            Here’s to new beginnings, bigger dreams, and a future full of success.

                            #GHRCACS #GHRCACSNagpur #Farewell2026 #CollegeFarewell #GraduationVibes #CampusLife
                            #StudentLife #NagpurEvents #FarewellParty #MemoriesForever #NewBeginnings 🎉" </p>
                    </div>
                </div>
                <div class="breadcrumb-overlay overflow-hidden" style="
              background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-1.webp);
            "></div>
            </div>
        </div>
    </div>
</section>

<div class="section-lg">
    <div class="container">
        <div class="sec-title text-center">
            <h2><span>Photo Gallery</span></h2>
        </div>
        <div class="demo-gallery photo-gallery">
            <ul class="lightgallery">
                <li class="grid-item1"
                    data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-2.webp"
                    data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-2.webp"
                    data-sub-html="&lt;p&gt;Farewell Party 2026 &lt;/p&gt;">
                    <a href="#">
                        <img loading="lazy" decoding="async" class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-2.webp" />
                    </a>
                </li>
                <li class="grid-item2"
                    data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-3.webp"
                    data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-3.webp"
                    data-sub-html="&lt;p&gt;Farewell Party 2026 &lt;/p&gt;">
                    <a href="#">
                        <img loading="lazy" decoding="async" class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-3.webp" />
                    </a>
                </li>
                <li class="grid-item3 d-none d-lg-block d-md-block"
                    data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-4.webp"
                    data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-4.webp"
                    data-sub-html="&lt;p&gt;Farewell Party 2026 &lt;/p&gt;">
                    <a href="#">
                        <img loading="lazy" decoding="async" class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-4.webp" />
                    </a>
                </li>
                <li class="grid-item4"
                    data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-5.webp"
                    data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-5.webp"
                    data-sub-html="&lt;p&gt;Farewell Party 2026 &lt;/p&gt;">
                    <a href="#">
                        <img loading="lazy" decoding="async" class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-5.webp" />
                    </a>
                </li>
                <li class="grid-item5"
                    data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-6.webp"
                    data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-6.webp"
                    data-sub-html="&lt;p&gt;Farewell Party 2026 &lt;/p&gt;">
                    <a href="#">
                        <img loading="lazy" decoding="async" class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-6.webp" />
                    </a>
                </li>
                <li class="grid-item6"
                    data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-1.webp"
                    data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-1.webp"
                    data-sub-html="&lt;p&gt;Farewell Party 2026 &lt;/p&gt;">
                    <a href="#">
                        <img loading="lazy" decoding="async" class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-1.webp" />
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
